import { useEffect } from 'react';
import { RELOAD_ON_ERROR_COUNTER } from '../constants';
import {
  isStaleChunkLoadError,
  tryReloadForStaleChunk,
} from '../utils/staleChunkLoadError';

function useErrorHandling() {
  const reloadFunc = (e) => {
    if (isStaleChunkLoadError(e?.error ?? e?.message)) {
      tryReloadForStaleChunk(e?.error ?? e?.message);
      return;
    }

    const reloadCounter: string | null = sessionStorage.getItem(
      RELOAD_ON_ERROR_COUNTER,
    );

    if (e.message?.includes('because its MIME type')) {
      if (reloadCounter && +reloadCounter < 2) {
        sessionStorage.setItem(
          RELOAD_ON_ERROR_COUNTER,
          `${+reloadCounter + 1}`,
        );
        window.location.reload();
      } else if (!reloadCounter) {
        sessionStorage.setItem(RELOAD_ON_ERROR_COUNTER, '1');
        window.location.reload();
      }
    }
  };

  useEffect(() => {
    window.addEventListener('error', reloadFunc);
    return () => {
      window.removeEventListener('error', reloadFunc);
    };
  }, []);
}

export default useErrorHandling;
